import { render, staticRenderFns } from "./OrderFoodMenuEdit.vue?vue&type=template&id=1909c2db&scoped=true"
import script from "./OrderFoodMenuEdit.vue?vue&type=script&lang=js"
export * from "./OrderFoodMenuEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodMenuEdit.vue?vue&type=style&index=0&id=1909c2db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1909c2db",
  null
  
)

export default component.exports